export default {"src":"/_next/static/media/flyboard.802d622b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};